import SolicitacaoFaturamentoMultiservico from './componentes/SolicitacaoFaturamentoMultiservico.vue';
import SolicitacaoFaturamentoMultiservicoLista from './componentes/SolicitacaoFaturamentoMultiservicoLista.vue';
import SolicitacaoFaturamentoMultiservicoForm from './componentes/SolicitacaoFaturamentoMultiservicoForm.vue';
import SolicitacaoFaturamentoMultiservicoRelatorio from './componentes/SolicitacaoFaturamentoMultiservicoRelatorio.vue';

export default {
  path: '/solicitacao-faturamento-multiservicos',
  component: SolicitacaoFaturamentoMultiservico,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoFaturamentoMultiservicoLista,
      name: 'solicitacao-faturamento-multiservicos',
    },
    {
      path: 'nova',
      component: SolicitacaoFaturamentoMultiservicoForm,
      name: 'solicitacao-faturamento-multiservicos.nova'
    },
    {
      path: ':id/relatorio',
      component: SolicitacaoFaturamentoMultiservicoRelatorio,
      name: 'solicitacao-faturamento-multiservicos.relatorio'
    },
    {
      path: ':id',
      component: SolicitacaoFaturamentoMultiservicoForm,
      name: 'solicitacao-faturamento-multiservicos.editar'
    }
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-faturamento-multiservicos/rotas.js